export default __webpack_public_path__ + "static/media/DSC05637.65b39f43.jpg";